<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= --> 

    function controlla_visibilita_taglie(){
      setInterval(function() {
        if ($('.csp-prod-form').length){
          $('.productView-options').hide();
        }
      }, 100); 
    }
  
    function check_count_bubble(){
        var valore_wl = $(".wishlist-count-bubble").find('span').html();
        if (valore_wl == 0){
          $(".wishlist-count-bubble").attr('style', 'display: none !important');
        }
        else{
          $(".wishlist-count-bubble").attr('style', 'display: block');
        }

        var valore_c = $($(".cart-count-bubble").find('span')[0]).html();
        if (valore_c == 0){
          $(".cart-count-bubble").attr('style', 'display: none !important');
        }
        else{
          $(".cart-count-bubble").attr('style', 'display: block');
        } 
    }
  
    $(document).ready(function () {
      $('#tab-dettagli').find(".toggleLink").addClass("is-open"); 
      $('#tab-dettagli-mobile').show();
      $(".wishlist-count-bubble").attr('style', 'display: none !important');
      $(".cart-count-bubble").attr('style', 'display: none !important');
 
      setTimeout(function() {
          check_count_bubble(); 
      }, 150);
      
      setInterval(function() {
          check_count_bubble(); 
      }, 1000);
    });